import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeAutoProlong } from '../../actions/checkoutInfo';
import { selectIsAutoProlongDisabled } from '../../selectors/checkoutInfo';
import { TDispatch } from '../../../common/types/dispatch';
import { Device } from '../common/Device';
import { AutoProlongDesktop } from './AutoProlong.desktop';
import { AutoProlongMobile } from './AutoProlong.mobile';
import { selectPaidPublication } from '../../reducers/v2/paidPublication/selectors';

export const AutoProlongContainer = () => {
  const { autoProlong: isChecked } = useSelector(selectPaidPublication);
  const isDisabled = useSelector(selectIsAutoProlongDisabled);

  const dispatch = useDispatch<TDispatch>();

  const handleChangeValue = React.useCallback(() => dispatch(changeAutoProlong(!isChecked)), [dispatch, isChecked]);

  const commonProps = {
    value: isChecked,
    isDisabled,
    onChange: handleChangeValue,
  };

  return <Device mobile={<AutoProlongMobile {...commonProps} />} desktop={<AutoProlongDesktop {...commonProps} />} />;
};
